module.exports = __webpack_public_path__ + "static/commerce2x-aws-4135010a1c70282971eb8177ef2512a0.png";